import allCountries from "assets/data/countries.json"

// TODO: is the key (aka "FR") necessary ?
export const countriesList = Object.values(allCountries).map((cityName) => ({
	label: cityName,
	value: cityName,
}))

// ICON
export const ICON_DEFAULT_SIZE = 24
